import React,{ useState } from "react";

import './styles.css'

import CloseIcon from '@mui/icons-material/Close';
import {
  Card, 
  Stack,
  IconButton,
  Avatar,
  Box,
  Chip,
  Typography,
} from '@mui/material';

import { LoadingButton } from '@mui/lab';

import { SortableElement, SortableContainer } from "react-sortable-hoc";
import {arrayMoveImmutable} from 'array-move';


const Item = SortableElement(({ value }) => <li>{value}</li>);

const ItemContainer = SortableContainer(({ items }) => (
  <ul>
    {items?.map((item, index) => (      
          <Item key={item.ordem} index={index} value={
            <Card>
                <Box sx={{ p: 2, display:'flex' }}>
                <Avatar variant="rounded" src={item.url} />
                <Stack marginLeft={1}>
                    <Typography variant="subtitle1">{item.name}</Typography>
                    <Typography sx={{color: '#595959'}} variant="body2">{item.category}</Typography>
                </Stack>
                <Chip sx={{marginLeft:2}}label={index+1} clickable />
                </Box>
            </Card>
        } />
    ))}
  </ul>

));

function ChangeOrderExs(props){
    
    const [items, setItems] = useState(props.sessao.exercises);
    //console.log(items);

    function onSortEnd({ oldIndex, newIndex }) {
        const updatedItems = arrayMoveImmutable(items, oldIndex, newIndex);
        setItems(updatedItems);
    }

  return (props.trigger) ? (
    <Box className="popup">
        <Box className="popup-inner">
            
            <Typography variant="h5">Arraste os cartões para trocar a ordem dos exercícios da sessão "{props.sessao.title}"</Typography>
            
            <Box className="Drag" sx={{height: 400, overflow: "hidden", overflowY: "scroll"}}>
                <ItemContainer items={items} onSortEnd={onSortEnd} />
            </Box>

            <LoadingButton fullWidth size="large" type="submit" variant="contained">
                Guardar
            </LoadingButton>
            

            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
        </Box>
    </Box>

  ) : "";
}
export default ChangeOrderExs
